import $appConfig from "servicestack/config";
import resolve from "ioc/resolve";
import Media from "webutils/media/media";
import shoppingConfig from "emun.shopping/shopping.config";
import cartConfig from "emun.cart/cart.config";
import DownloadImagesPrompt from "emun.cart/download-cart-images-prompt";
import missingImage from "webutils/imgs/image-coming-soon.jpg";
import ServiceBus from "servicestack/service-bus";
import $session from "servicestack/session";
import isString from "lodash/isString";

const onDemandPath = "https://s3.amazonaws.com/emun-on-demand/";

export default class Product {
  constructor(dto) {
    Object.assign(this, dto);
    if (!this.productId && this.id) {
      this.productId = this.id;
    }
    if (!this.id && this.productId) this.id = this.productId;
    
    (this.areas || []).forEach((a) =>
      (a.overlays || [])
        .concat(a.underlays || [])
        .forEach((o) => (o.media = new Media(o.media)))
    );
    this.images = (this.images || []).map((i) => new Media(i));
    this.metaImageTag = `<head><meta property="og:image" content="${this.img(
      "large"
    )}" /></head>`;

    this.priceBreaks = [];
    if (this.pricing) {
      Object.keys(this.pricing || {})
        .map((qty) => parseFloat(qty))
        //.sort()
        .forEach((qty) =>
          this.priceBreaks.push({ qty, price: this.pricing[qty] })
        );
    }

    this.components = [];
    if (this.meta && this.meta.Components) {
      this.components = JSON.parse(this.meta.Components);
    }
    this.documents = (this.documents || []).map((d) => new Media(d));
    this.openOrder = {};
    this.orders = [];
    this.kitOnCurrentOrder = false;
    this.kitOnOpenOrder = false;
    this.componentOnOpenOrder = false;
    this.kitOnInvoices = false;
    var kitLatest = null;
    if (this.meta) {
      if (isString(this.meta.Components))
        this.components = JSON.parse(this.meta.Components);
      if (isString(this.meta.Kits)) this.kits = JSON.parse(this.meta.Kits);
      if (isString(this.meta.Media)) this.media = JSON.parse(this.meta.Media);
      if (isString(this.meta.Orders) && this.meta.Orders != "[]") {
        this.orders = JSON.parse(this.meta.Orders);
        this.openOrder = this.orders[0];
      }
      if (isString(this.meta.Invoices))
        this.invoices = JSON.parse(this.meta.Invoices);
      if (isString(this.meta.Parts)) this.parts = JSON.parse(this.meta.Parts);
      if (isString(this.meta.Commitments) && this.meta.Commitments != "[]") {
        this.commitments = JSON.parse(this.meta.Commitments);
        this.isCommited = this.commitments.length > 0 ? true : false;
        this.commitmentFulfilled = this.isCommited && this.orders.length > 0 ? true : false;
      }
      if (isString(this.meta.Interests) && this.meta.Interests != "[]") {
        this.interests = JSON.parse(this.meta.Interests);
        this.isInterested = this.interests.length > 0 ? true : false;
      }
    }
    this.generateHighlights();
    this.lastShipped = "";
  }

  static Highlight() {
    return {};
  }

  static map(products) {
    return (products || []).map((p) => new Product(p));
  }

  static get(id) {
    const $cart = resolve("$cart") || {}; // for cartless plugin
    return ServiceBus.read(
      `QueryProducts.json?${
        $session.isCorpOrAbove() ? "IncludeInactive=1" : "Status=Active"
      }`,
      {
        id,
        cartId: $cart.id ? $cart.id : null,
        retailerId: $cart.retailerId ? $cart.retailerId : null,
      }
    ).then(
      (res) =>
        new Product(
          res.data.results.length > 0 ? res.data.results[0] : { id, $faked: 1 }
        )
    );
  }

  static getByIds(productIds) {
    const $cart = resolve("$cart") || {}; // for cartless plugin
    return ServiceBus.read(`QueryProducts.json`, {
      idIn: productIds,
      cartId: $cart.id ? $cart.id : null,
      retailerId: $cart.retailerId ? $cart.retailerId : null,
    }).then((res) => res.data.results.map((p) => new Product(p)));
  }

  generateHighlights() {
    const $cart = resolve("$cart") || {}; // for cartless plugin
    //console.debug('highlight', this);
    this.highlights = [];

    if ($cart && Array.isArray(this.kits) && this.kits.length) {
      this.kits.map((k) => {
        if (k.Id in $cart.itemIndex) this.kitOnCurrentOrder = true;
        if (k.Orders) {
          this.kitOnOpenOrder = true;
          this.kitLatest = _.max(k.Orders, "OrderedOn");
        }
        if (k.Invoices) {
          this.kitOnInvoices = true;
          this.kitInvoiceLatest = _.max(k.Invoices, "InvoicedOn");
        }
      });
    }
    if ($cart && Array.isArray(this.components) && this.components.length) {
      this.components.map((c) => {
        if (c.Orders) {
          this.componentOnOpenOrder = true;
          this.componentLatest = _.max(c.Orders, "OrderedOn");
        }
      });
    }

    if (
      this.tags &&
      this.tags["Stock Status"] &&
      this.tags["Stock Status"] !== ""
    ) {
      // console.info('tags', this.tags['Stock Status'], this.tags['SaleItem']);
      var d = moment(this.tags["Stock Status"]);
      if (d.isValid()) {
        const dur = moment.duration(
          moment(this.tags["Stock Status"]).diff(moment())
        );
        this.highlights.push({
          icon: dur.asDays() > 30 ? "icon-circle-o" : "icon-circle-c",
          html: dur.asDays() > 30 ? "&#xe900" : "&#xe901",
          fontFamily: "legendicons",
          title: "Available On",
          code: "out-of-stock",
          color: dur.asDays() > 30 ? "red" : "orange",
          description: `more on ${this.tags["Stock Status"]}; ${dur.humanize(
            true
          )}`,
        });
      } else {
        if (
          this.status === "Active" &&
          (this.tags["Stock Status"][0] === "InStock" ||
            this.tags["Stock Status"][0] === "In Stock")
        ) {
          this.highlights.push({
            icon: "icon-circle-s",
            html: "&#xe906",
            fontFamily: "legendicons",
            title: "In Stock",
            color: "green",
            code: "in-stock",
            description: `${this.availableQty} available unit(s)`,
          });
        } else if ((this.tags["Stock Status"][0] || "").toLowerCase() === "low stock") {
          this.highlights.push({
            icon: "icon-circle-o",
            html: "&#xe900",
            fontFamily: "legendicons",
            title: "Low Stock",
            color: "black",
            code: "low-stock",
            description: `low stock`,
          });
        } else if ((this.tags["Stock Status"][0] || "").toLowerCase() === "out of stock") {
          this.highlights.push({
            icon: "icon-circle-o",
            html: "&#xe900",
            fontFamily: "legendicons",
            title: "Out of Stock",
            color: "black",
            code: "out-of-stock",
            description: `out of stock`,
          });
        }
      }
    }
    if (
      this.tags &&
      this.tags["SaleItem"] &&
      this.tags["SaleItem"][0] === "Yes"
    ) {
      this.highlights.push({
        icon: "icon-circle-dot",
        html: "&#xe905",
        fontFamily: "legendicons",
        title: "Sale Item",
        color: "black",
        code: "sale-item",
        description: `$sale item`,
      });
    }
    if (Array.isArray(this.media) && this.media.length) {
      this.highlights.push({
        icon: "icon-circle-video",
        html: "&#xe908",
        fontFamily: "legendicons",
        title: "Media available",
        color: "black",
        description: `${this.media.length} item(s)`,
      });
    }

    if ($cart && $cart.itemIndex && this.id in $cart.itemIndex) {
      this.highlights.push({
        icon: "icon-circle-dot",
        html: "&#xe905",
        fontFamily: "legendicons",
        title: `On Current order`,
        color: "green",
        code: "in-cart",
        description: `On current order ${$cart.id}`,
      });
    } else if (
      $cart &&
      $cart.itemIndex &&
      Array.isArray(this.kits) &&
      this.kits.length &&
      this.kitOnCurrentOrder
    ) {
      this.highlights.push({
        icon: "icon-circle-dot",
        html: "&#xe905",
        fontFamily: "legendicons",
        title: `Part of kit On Current order`,
        color: "green",
        code: "in-cart",
        description: `Part of kit on current order ${$cart.id}`,
      });
    } else if (Array.isArray(this.orders) && this.orders.length) {
      const latest = _.max(this.orders, "OrderedOn");
      this.highlights.push({
        icon: "icon-circle-dot",
        html: "&#xe905",
        fontFamily: "legendicons",
        title: `${latest.Status} ${latest.OrderId}`,
        color: "orange",
        description: `Last ordered on ${latest.OrderedOn}`,
      });
      this.openOrder = latest;
    } else if (
      $cart &&
      $cart.itemIndex &&
      Array.isArray(this.kits) &&
      this.kits.length &&
      this.kitOnOpenOrder
    ) {
      this.highlights.push({
        icon: "icon-circle-dot",
        html: "&#xe905",
        fontFamily: "legendicons",
        title: `${this.kitLatest.Status} ${this.kitLatest.OrderId}`,
        color: "orange",
        description: `Part of kit last ordered on ${this.kitLatest.OrderedOn}`,
      });
      this.openOrder = this.kitLatest;
    } else if (
      $cart &&
      $cart.itemIndex &&
      Array.isArray(this.components) &&
      this.components.length &&
      this.componentOnOpenOrder
    ) {
      this.highlights.push({
        icon: "icon-circle-dot",
        html: "&#xe905",
        fontFamily: "legendicons",
        title: `${this.componentLatest.Status} ${this.componentLatest.OrderId}`,
        color: "orange",
        description: `Last ordered on ${this.componentLatest.OrderedOn}`,
      });
      this.openOrder = this.componentLatest;
    }
    if (Array.isArray(this.invoices) && this.invoices.length) {
      const last = this.invoices[this.invoices.length - 1];
      const dur = moment.duration(moment(last.InvoicedOn).diff(moment()));
      if (dur.asDays() <= 365) {
        this.highlights.push({
          icon: "icon-circle-dot",
          html: "&#xe905",
          fontFamily: "legendicons",
          title: "Recent Invoice #" + last.InvoiceId,
          color: "#00caca",
          description: `Last received ${last.InvoicedOn}; ${dur.humanize(
            true
          )}`,
        });
        this.lastShipped = last.InvoicedOn;
      }
    } else if (
      $cart &&
      $cart.itemIndex &&
      Array.isArray(this.kits) &&
      this.kits.length &&
      this.kitOnInvoices
    ) {
      const dur = moment.duration(
        moment(this.kitInvoiceLatest.InvoicedOn).diff(moment())
      );
      if (dur.asDays() <= 365) {
        this.highlights.push({
          icon: "icon-circle-dot",
          html: "&#xe905",
          fontFamily: "legendicons",
          title: "Recent Invoice #" + this.kitInvoiceLatest.InvoiceId,
          color: "#00caca",
          description: `Part of kit last received on ${this.kitInvoiceLatest.InvoicedOn}`,
        });
        this.lastShipped = this.kitInvoiceLatest.InvoicedOn;
      }
    }

    if (this.tags) {
      if (this.tags["Top Reordered"]) {
        this.highlights.push({
          icon: "icon-circle-dollar",
          html: "&#xe904",
          fontFamily: "legendicons",
          title: "Top Reordered",
          code: "top-reordered",
          color: "gold",
          description: `Top Reordered`,
        });
      }
    }

    if (this.status) {
      this.highlights.push({
        // icon: "icon-circle-dollar",
        // html: "&#xe904",
        // fontFamily: "legendicons",
        title: this.status,
        code: this.status,
        color: this.status.toLowerCase().replace(/\s+/gi, "-"),
        description: this.status,
      });
    }
    return this.highlights;
  }

  downloadPrompt(ext) {
    return DownloadImagesPrompt({
      subTitle: this.id + " - " + this.shortDescription,
      productId: this.id,
    });
  }

  getImageUrl(size, ext) {
    return this.img(size, ext);
  }

  getCompositeImages() {
    let images = [];
    (this.images || []).forEach((img) => {
      if (img.isDesign()) {
        images.push(img);
      }
    });
    return images;
  }

  getOverlayImages() {
    let overlays = [];
    (this.areas || []).forEach((a) => {
      (a.overlays || []).concat(a.underlays || []).forEach((o) => {
        if (o.isProductImage && o.media && o.media.url) {
          let m = Object.assign({}, o.media, {
            url: Media.getUrl(a.design.url, o.euid + "/large.jpg"),
          });
          overlays.push(new Media(m));
        }
      });
    });
    return overlays;
  }

  imgs(size, ext) {
    //console.info("pid: " + this.id + " : img size: " + size);
    //console.info(this._imgs);
    //if (this._imgs) return this._imgs;
    const results = [];
    const staticImage = $appConfig.productImage(
      this.id,
      size,
      ext,
      "m=" + this.modAt() + "&=im" + this.imgModAt(1)
    );
    const localImage = $appConfig.localProductImage(
      this.id,
      size,
      ext,
      "m=" + this.modAt() + "&=im" + this.imgModAt(1)
    );
    if (shoppingConfig.productImagesPriority) {
      if ($appConfig.isOffline) results.push(localImage);
      results.push(staticImage);
    }

    let images = this.getCompositeImages()
      .concat(this.getOverlayImages())
      .concat(this.images);
    for (var i in images) {
      let image = images[i];
      if (image.url && image.url.indexOf("emun-on-demand") > 0)
        results.push(image.img(size, ext));
    }
    if (!shoppingConfig.productImagesPriority) {
      if ($appConfig.isOffline) results.push(localImage);
      results.push(staticImage);
    }
    results.push(missingImage);
    this._imgs = results;
    return results;
  }

  img(size, ext) {
    return this.imgs(size, ext)[0];
  }

  jpg(size) {
    return this.img(size, "jpg");
  }

  png(size) {
    return this.img(size, "png");
  }

  modAt() {
    return this.tags && this.tags.$ModifiedAt && this.tags.$ModifiedAt[0];
  }

  imgModAt(position) {
    const { productImages = [] } = this || {};
    const [{ createdOn = position } = {}] = productImages.filter(
      (m) => m.position === position
    );
    return createdOn;
  }

  altimg(position, size, ext) {
    if (position == 1) {
      return this.img(size, ext);
    } else if ($appConfig.isOffline) {
      return $appConfig.localAlternateImage(
        this.id,
        position,
        size,
        ext,
        "m=" + this.modAt() + "&=im" + this.imgModAt(position)
      );
    } else {
      return $appConfig.alternateImage(
        this.id,
        position,
        size,
        ext,
        "m=" + this.modAt() + "&=im" + this.imgModAt(position)
      );
    }
  }

  getCartItem(cartId, newIfHasOptions = true) {
    let product = this;
    let $cart = resolve("$cart") || {}; // for cartless plugin
    let cartItem = $cart.itemIndex[product.id];
    if (!cartItem || ((cartItem.options || []).length > 0 && newIfHasOptions))
      cartItem = product.createCartItem(cartId);
    if (!cartItem.product) cartItem.product = product;
    return cartItem;
  }

  createCartItem(cartId, comments, quantity, options, optionGroupList, shipOn) {
    let product = this;
    let $cart = resolve("$cart") || {}; // for cartless plugin
    let cartItem = {
      createdOn: new Date(),
      product,
      cartId: cartId || $cart.cartId || $cart.id,
      configId: product.meta && product.meta.ConfigId,
      prebuiltId: product.meta && product.meta.ConfigId,
      productId: product.id,
      quantity: quantity || product.minimumOrderQty || 1,
      options: options || product.options || product.asShownValues || [],
      optionGroupList,
      comments,
      shipOn: shipOn || product.shipOn || $cart.shipOn,
    };
    //if (moment($cart.shipOn) > moment(cartItem.shipOn)) cartItem.shipOn = $cart.shipOn;
    if (
      cartConfig.defaultShipDatePrev &&
      moment($cart.lastShipDate) > moment(cartItem.shipOn)
    )
      cartItem.shipOn = $cart.lastShipDate;
    resolve("$rootScope").$emit("creatingCartItem", { cartItem });

    return cartItem;
  }

  isConfigurable() {
    let product = this;
    return (
      (product.optionGroup ||
        (product.meta != undefined && product.meta.MaxNumLines)) &&
      !(product.asShownValues || []).length
    );
  }

  isPersonalizeable() {
    let product = this;
    return product.meta != undefined && product.meta.MaxNumLines;
  }

  isInCart() {
    let product = this;
    let $cart = resolve("$cart") || {}; // for cartless plugin
    //console.info("cart", $cart);
    return $cart.hasItem(product.id);
    //return resolve("$cart").hasItem(product.id);
  }

  cartItems() {
    let product = this;
    return resolve("$cart").items.filter((i) => i.productId == this.id);
  }

  cartPositions() {
    return this.cartItems().map((i) => i.position);
  }
}
